/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
import * as c from "react";
import { classNames as n, IconWrap as t, toIconName as a } from "@progress/kendo-react-common";
const m = (e) => /* @__PURE__ */ c.createElement(
  "div",
  {
    onClick: e.onClick,
    className: n(
      "k-columnmenu-item",
      { "k-selected": e.selected },
      { "k-disabled": e.disabled }
    )
  },
  (e.iconClass || e.svgIcon) && /* @__PURE__ */ c.createElement(t, { name: e.iconClass ? a(e.iconClass) : void 0, icon: e.svgIcon }),
  e.title
);
export {
  m as ColumnMenuItem
};
